"use strict";

const $ = window.jQuery || {};
const Handlebars = window.Handlebars || {};
const LumerisSalesforceEventsModule = require('./lumeris-salesforce-events-module.js');
const LumerisSalesforceMemberMeetingsModule = require('./lumeris-salesforce-member-meetings-module.js');

class LumerisSalesforceEventsPlugin {
    #initialized = false;

    $lseModules = [];
    $lsmmModules = [];

    lseModules = [];
    lsmmModules = [];
    
    constructor() {
        this.bind();
    }

    bind() {
        $(document).on('ready', (event) => { this.tryInit(); });

        document.addEventListener('DOMContentLoaded', (event) => { this.tryInit(); });
        window.addEventListener('load', (event) => { this.tryInit(); });
        window.onload = () => { this.tryInit(); };
    }

    tryInit() {
        if (!this.initialized) {
            this.initialized = true;
            this.init();
        }
    }

    init() {
        if (typeof Handlebars !== 'undefined' && typeof Handlebars.registerHelper !== 'undefined') {
            Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
                return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
            });
        
            Handlebars.registerHelper('unlessEquals', function(arg1, arg2, options) {
                return (arg1 == arg2) ? options.inverse(this) : options.fn(this);
            });
        
            Handlebars.registerHelper('toJSON', function(obj) {
                return JSON.stringify(obj);
            });
        }

        this.$lseModules = $('.lumeris-salesforce-events');
        this.$lsmmModules = $('.lumeris-salesforce-member-meetings');

        this.$lseModules.each((moduleIndex, moduleElement) => { 
            setTimeout(() => {
                this.lseModules.push(new LumerisSalesforceEventsModule(moduleIndex, moduleElement)); 
            }, 0);
        });

        this.$lsmmModules.each((moduleIndex, moduleElement) => {
            setTimeout(() => {
                this.lsmmModules.push(new LumerisSalesforceMemberMeetingsModule(moduleIndex, moduleElement));
            }, 0);
        });
    }

    get initialized() {
        return this.#initialized;
    }

    set initialized(value) {
        this.#initialized = value;
    }
}

window.LumerisSalesforceEventsPlugin = new LumerisSalesforceEventsPlugin();